// extracted by mini-css-extract-plugin
export default {"buttonStyle":"CustomButtonLightBg_buttonStyle__2c5f1"};